!function (e, a) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = a() : "function" == typeof define && define.amd ? define(a) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.tr = a());
}(this, function () {
  "use strict";

  return [{
    locale: "tr",
    pluralRuleFunction: function pluralRuleFunction(e, a) {
      return a ? "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "yıl",
        relative: {
          0: "bu yıl",
          1: "gelecek yıl",
          "-1": "geçen yıl"
        },
        relativeTime: {
          future: {
            one: "{0} yıl sonra",
            other: "{0} yıl sonra"
          },
          past: {
            one: "{0} yıl önce",
            other: "{0} yıl önce"
          }
        }
      },
      "year-short": {
        displayName: "yıl",
        relative: {
          0: "bu yıl",
          1: "gelecek yıl",
          "-1": "geçen yıl"
        },
        relativeTime: {
          future: {
            one: "{0} yıl sonra",
            other: "{0} yıl sonra"
          },
          past: {
            one: "{0} yıl önce",
            other: "{0} yıl önce"
          }
        }
      },
      month: {
        displayName: "ay",
        relative: {
          0: "bu ay",
          1: "gelecek ay",
          "-1": "geçen ay"
        },
        relativeTime: {
          future: {
            one: "{0} ay sonra",
            other: "{0} ay sonra"
          },
          past: {
            one: "{0} ay önce",
            other: "{0} ay önce"
          }
        }
      },
      "month-short": {
        displayName: "ay",
        relative: {
          0: "bu ay",
          1: "gelecek ay",
          "-1": "geçen ay"
        },
        relativeTime: {
          future: {
            one: "{0} ay sonra",
            other: "{0} ay sonra"
          },
          past: {
            one: "{0} ay önce",
            other: "{0} ay önce"
          }
        }
      },
      day: {
        displayName: "gün",
        relative: {
          0: "bugün",
          1: "yarın",
          2: "öbür gün",
          "-2": "evvelsi gün",
          "-1": "dün"
        },
        relativeTime: {
          future: {
            one: "{0} gün sonra",
            other: "{0} gün sonra"
          },
          past: {
            one: "{0} gün önce",
            other: "{0} gün önce"
          }
        }
      },
      "day-short": {
        displayName: "gün",
        relative: {
          0: "bugün",
          1: "yarın",
          2: "öbür gün",
          "-2": "evvelsi gün",
          "-1": "dün"
        },
        relativeTime: {
          future: {
            one: "{0} gün sonra",
            other: "{0} gün sonra"
          },
          past: {
            one: "{0} gün önce",
            other: "{0} gün önce"
          }
        }
      },
      hour: {
        displayName: "saat",
        relative: {
          0: "bu saat"
        },
        relativeTime: {
          future: {
            one: "{0} saat sonra",
            other: "{0} saat sonra"
          },
          past: {
            one: "{0} saat önce",
            other: "{0} saat önce"
          }
        }
      },
      "hour-short": {
        displayName: "sa.",
        relative: {
          0: "bu saat"
        },
        relativeTime: {
          future: {
            one: "{0} sa. sonra",
            other: "{0} sa. sonra"
          },
          past: {
            one: "{0} sa. önce",
            other: "{0} sa. önce"
          }
        }
      },
      minute: {
        displayName: "dakika",
        relative: {
          0: "bu dakika"
        },
        relativeTime: {
          future: {
            one: "{0} dakika sonra",
            other: "{0} dakika sonra"
          },
          past: {
            one: "{0} dakika önce",
            other: "{0} dakika önce"
          }
        }
      },
      "minute-short": {
        displayName: "dk.",
        relative: {
          0: "bu dakika"
        },
        relativeTime: {
          future: {
            one: "{0} dk. sonra",
            other: "{0} dk. sonra"
          },
          past: {
            one: "{0} dk. önce",
            other: "{0} dk. önce"
          }
        }
      },
      second: {
        displayName: "saniye",
        relative: {
          0: "şimdi"
        },
        relativeTime: {
          future: {
            one: "{0} saniye sonra",
            other: "{0} saniye sonra"
          },
          past: {
            one: "{0} saniye önce",
            other: "{0} saniye önce"
          }
        }
      },
      "second-short": {
        displayName: "sn.",
        relative: {
          0: "şimdi"
        },
        relativeTime: {
          future: {
            one: "{0} sn. sonra",
            other: "{0} sn. sonra"
          },
          past: {
            one: "{0} sn. önce",
            other: "{0} sn. önce"
          }
        }
      }
    }
  }, {
    locale: "tr-CY",
    parentLocale: "tr"
  }];
});